// Copyright (c) 2019 Deere & Company

export const getBasePath = () => {
    return process.env.REACT_APP_API_URL;
};
